import type { CancelEnrollmentByCourseId200Result } from './cancelEnrollmentByCourseId200Result';

export type CancelEnrollmentByCourseId200 = {
  /** 취소 일시 */
  cancelledAt: string;
  /**
   * 환불 금액
   * @nullable
   */
  refundAmount?: number | null;
  /** 환불 비율 */
  refundPercentage: number;
  result: CancelEnrollmentByCourseId200Result;
};
